import type { RouteRecordRaw } from 'vue-router'

import {
  routeAccountingDashboardHome,
  routeAccountingDashboardRoot,
} from './accountingDashboardRoutes'
import { routeAccountingReportsRoot } from './accountingReportsRoutes'
import { routeAutoRepeatsRoot } from './autoRepeatsRoutes'
import { routeDunningsRoot } from './dunningRoutes'
import { routeEInvoiceImportsRoot } from './eInvoiceImportsRoutes'
import { routePaymentEntriesRoot } from './paymentEntriesRoutes'
import { routePurchaseInvoicesRoot } from './puchaseInvoiceRoutes'
import { routeSalesInvoicesRoot } from './salesInvoiceRoutes'

const routeAccountingsHome: RouteRecordRaw = {
  name: 'accountings-home',
  path: '',
  redirect: routeAccountingDashboardHome,
}

const routeAccountingsRoot: RouteRecordRaw = {
  children: [
    routeAccountingsHome,
    routeAccountingDashboardRoot,
    routeSalesInvoicesRoot,
    routePurchaseInvoicesRoot,
    routePaymentEntriesRoot,
    routeAutoRepeatsRoot,
    routeDunningsRoot,
    routeEInvoiceImportsRoot,
    routeAccountingReportsRoot,
  ],

  path: 'accountings',
}

export { routeAccountingDashboardHome, routeAccountingsHome, routeAccountingsRoot }
